import type { Translations } from './de'

const uk: Translations = {
  'language.flag': '🇺🇦',
  'language.name': 'Українська',
  'navigation.home': 'Головна',
  'navigation.language': 'Мова',
  'navigation.openMenu': 'Відкрити меню',
  'navigation.closeMenu': 'Закрити меню',
  'navigation.skipToContent': 'Перейти до вмісту',
  'categories.sightseeing.name': 'Пам’ятки',
  'categories.sightseeing.heading': 'Найпопулярніші пам’ятки Аугсбурга',
  'categories.sightseeing.lead': 'Від Світової спадщини ЮНЕСКО до Фуггерай: Аугсбург може запропонувати більше, ніж ти думаєш.',
  'categories.events.name': 'Події',
  'categories.events.heading': 'Усі події з першого погляду',
  'categories.events.lead': 'Концерти, ярмарки, екскурсії містом: дізнайся, що відбувається в Аугсбурзі цього тижня.',
  'categories.blog.name': 'Новини',
  'categories.blog.heading': 'Новини з Аугсбурга',
  'categories.blog.lead': 'Передісторії, історія міста та актуальні теми, щоб читати й розповідати далі.',
  'categories.emptyTitle': 'Тут поки нічого немає',
  'categories.emptyDescription': 'У цьому розділі ще немає сторінок. Зазирни сюди згодом.',
  'home.title': 'Ласкаво просимо до Аугсбурга',
  'home.intro': 'Міська подорож, ділова поїздка чи візит до родини: тут ти знайдеш усю важливу інформацію для свого перебування в Аугсбурзі.',
  'home.sightseeing.eyebrow': 'Місто Світової спадщини ЮНЕСКО',
  'home.sightseeing.title': 'Відкрий пам’ятки',
  'home.sightseeing.lead': 'Від Світової спадщини ЮНЕСКО до Фуггерай: Аугсбург може запропонувати більше, ніж ти думаєш.',
  'home.sightseeing.action': 'Відкрити зараз',
  'home.events.eyebrow': 'Що відбувається в Аугсбурзі?',
  'home.events.title': 'Знайти події',
  'home.events.lead': 'Більше не пропускай концертів, блошиних ринків і фестивалів. На нашій сторінці подій ти завжди в курсі.',
  'home.events.action': 'Усі події',
  'home.blog.eyebrow': 'Історії з міста',
  'home.blog.title': 'Новини та цікаве',
  'home.blog.lead': 'Тут ти знайдеш усе важливе про Аугсбург, щоб нічого не пропустити під час візиту.',
  'home.blog.action': 'До блогу',
  'home.language.eyebrow': 'Аугсбург – міжнародне місто',
  'home.language.title': 'Перейти на твою мову',
  'home.language.lead': 'Цей сайт доступний кількома мовами. Хочеш змінити мову?',
  'home.highlights.eyebrow': 'Підібрано для тебе',
  'home.highlights.title': 'Наші рекомендації',
  'home.highlights.lead': 'Для гарного початку ми зібрали для тебе кілька найцікавіших місць Аугсбурга. Приємного читання!',
  'search.placeholder': 'Пошук...',
  'search.clear': 'Очистити пошук',
  'search.label': 'Пошук сторінок',
  'search.results': '{{count}} результатів для «{{query}}»',
  'search.emptyTitle': 'Нічого не знайдено',
  'search.emptyDescription': 'За цим запитом ми нічого не знайшли. Спробуй інше слово.',
  'pagination.label': 'Сторінки',
  'pagination.previous': 'Попередня сторінка',
  'pagination.next': 'Наступна сторінка',
  'pagination.page': 'Сторінка {{page}}',
  'pagination.summary': '{{start}}–{{end}} з {{total}}',
  'page.back': 'Назад',
  'page.readMore': 'Докладніше',
  'page.tableOfContents': 'На цій сторінці',
  'page.openInGoogleMaps': 'Відкрити в Google Картах',
  'map.copyAddress': 'Копіювати адресу',
  'map.copied': 'Скопійовано',
  'map.copyFailed': 'Не вдалося скопіювати',
  'map.routeInGoogleMaps': 'Маршрут у Google Картах',
  'map.zoomIn': 'Збільшити',
  'map.zoomOut': 'Зменшити',
  'map.showAll': 'Показати все',
  'attribution.toggle': 'Показати або приховати джерела',
  'map.gestures.windows': 'Використовуйте Ctrl + прокручування, щоб масштабувати карту',
  'map.gestures.mac': 'Використовуйте ⌘ + прокручування, щоб масштабувати карту',
  'map.gestures.mobile': 'Переміщуйте карту двома пальцями',
  'map.loading': 'Карта завантажується …',
  'map.failed': 'Не вдалося завантажити карту.',
  'map.showPlace': 'Показати {{name}} на карті',
  'map.marker': '{{name}}, {{icon}}',
  'map.numberedMarker': '{{number}}. {{name}}, {{icon}}',
  'map.route.walkingTime': 'приблизно {{duration}} пішки',
  'map.route.stops': 'Зупинок: {{count}}',
  'map.route.leg': '{{distance}} · приблизно {{duration}}',
  'mapIcons.landmark': 'Пам’ятка',
  'mapIcons.church': 'Церква',
  'mapIcons.museum': 'Музей',
  'mapIcons.park': 'Парк і природа',
  'mapIcons.viewpoint': 'Оглядовий майданчик',
  'mapIcons.cafe': 'Кав’ярня',
  'mapIcons.bar': 'Бар',
  'mapIcons.restaurant': 'Ресторан',
  'mapIcons.shop': 'Покупки',
  'mapIcons.event': 'Місце подій',
  'mapIcons.transport': 'Транспорт',
  'mapIcons.place': 'Місце',
  'footer.imprint': 'Вихідні дані',
  'footer.privacy': 'Політика конфіденційності',
  'footer.mediaLicense': 'Права на зображення',
  'legal.bindingNote': 'Цей переклад надається лише для інформації. Юридично обов’язковою є тільки німецька версія.',
  'imprint.provider.heading': 'Відомості відповідно до § 5 DDG',
  'imprint.contact.heading': 'Контакт',
  'imprint.contact.email': 'Електронна пошта',
  'imprint.responsible.heading': 'Відповідальний за зміст відповідно до § 18 абз. 2 MStV',
  'privacy.intro': 'Ця політика конфіденційності пояснює, які персональні дані обробляються, коли ти відвідуєш цей вебсайт.',
  'privacy.controller.heading': 'Контролер даних',
  'privacy.controller.text': 'Відповідальним за обробку даних на цьому вебсайті є:',
  'privacy.hosting.heading': 'Хостинг',
  'privacy.hosting.text': 'Цей вебсайт розміщено у зовнішнього хостинг-провайдера з місцезнаходженням у Німеччині. Сервери розташовані в Німеччині.',
  'privacy.serverLogs.heading': 'Журнали сервера',
  'privacy.serverLogs.text': 'Під час кожного відвідування цього вебсайту сервер автоматично зберігає інформацію, яку передає твій браузер: IP-адресу, дату й час запиту, відкриту сторінку, обсяг переданих даних, URL-адресу переходу, а також браузер і операційну систему. Ці дані потрібні для безпечної та стабільної роботи вебсайту (ст. 6 ч. 1 п. f GDPR) і видаляються не пізніше ніж через 7 днів.',
  'privacy.analytics.heading': 'Вимірювання відвідуваності',
  'privacy.analytics.text': 'Щоб знати, які сторінки читають, ми самі рахуємо перегляди сторінок, без зовнішніх сервісів і без файлів cookie. Коли ти відкриваєш сторінку, твій браузер повідомляє нашому серверу лише її адресу. Для кожної адреси, мови й дня ми зберігаємо тільки кількість переглядів, окремо для браузерів і автоматизованих програм (пошукових роботів), які розрізняємо за ідентифікатором браузера (user agent). Твоя IP-адреса, ідентифікатор браузера чи інші дані про тебе для цього не зберігаються; встановити окремих відвідувачів неможливо. Якщо твій браузер надсилає сигнал «Global Privacy Control» або «Do Not Track», твій перегляд не враховується. Дані видаляються через рік. Правовою підставою є ст. 6 ч. 1 п. f GDPR; наш законний інтерес — покращення цього вебсайту.',
  'privacy.errorReports.heading': 'Звіти про помилки',
  'privacy.errorReports.text': 'Якщо під час завантаження сторінки виникає технічна помилка, оператору автоматично надсилається електронний лист з інформацією про невдалий запит. Він може містити твою IP-адресу, відкриту адресу та дані про твій браузер. Звіти про помилки використовуються виключно для усунення помилок (ст. 6 ч. 1 п. f GDPR).',
  'privacy.cookies.heading': 'Файли cookie',
  'privacy.cookies.text': 'Цей вебсайт використовує лише технічно необхідні файли cookie, потрібні для твоєї сесії та захисту від підроблених запитів (CSRF). Вони не містять даних для аналітики чи реклами і видаляються після закриття браузера. Правовою підставою є § 25 абз. 2 № 2 TDDDG у поєднанні зі ст. 6 ч. 1 п. f GDPR; згода не потрібна. Зовнішні сервіси аналітики чи відстеження не використовуються; описане вище вимірювання відвідуваності працює без файлів cookie.',
  'privacy.rights.heading': 'Твої права',
  'privacy.rights.text': 'Ти маєш право на:',
  'privacy.rights.access': 'доступ до своїх збережених даних (ст. 15 GDPR)',
  'privacy.rights.rectification': 'виправлення (ст. 16 GDPR)',
  'privacy.rights.erasure': 'видалення (ст. 17 GDPR)',
  'privacy.rights.restriction': 'обмеження обробки (ст. 18 GDPR)',
  'privacy.rights.portability': 'перенесення даних (ст. 20 GDPR)',
  'privacy.rights.objection': 'заперечення проти обробки (ст. 21 GDPR)',
  'privacy.rights.contact': 'Щоб скористатися цими правами, просто напиши електронного листа на адресу:',
  'privacy.complaint.heading': 'Право на скаргу',
  'privacy.complaint.text': 'Ти маєш право подати скаргу до наглядового органу із захисту даних. Компетентним органом є Баварське державне управління з нагляду за захистом даних (BayLDA), Promenade 18, 91522 Ansbach, Німеччина.',
  'privacy.updated': 'Останнє оновлення: жовтень 2026',
  'mediaLicense.intro': 'Усі фото, відео, документи та маршрути на цьому вебсайті належать Visit Augsburg. Ти можеш використовувати, поширювати та змінювати їх за ліцензією Creative Commons Із зазначенням авторства 4.0 Міжнародна (CC BY 4.0) – також у комерційних цілях – за умови, що зазначиш нас як джерело.',
  'mediaLicense.credit.heading': 'Як зазначити нас як джерело',
  'mediaLicense.credit.text': 'Показуй цю примітку добре помітно, безпосередньо біля зображення чи відео:',
  'mediaLicense.credit.link': 'За можливості дай посилання на сторінку, з якої походить матеріал, і на ліцензію. Якщо ти змінив матеріал, зазнач це.',
  'mediaLicense.ai.heading': 'ШІ-асистенти та пошукові системи',
  'mediaLicense.ai.text': 'Це стосується також чат-ботів, ШІ-асистентів і пошукових систем: хто показує зображення чи відео з цього вебсайту, показує разом із ним примітку «{{credit}}». Автор, примітка та ліцензія в машиночитному вигляді містяться в кожному файлі зображення (IPTC/XMP) і в структурованих даних (schema.org) кожної сторінки.',
  'mediaLicense.license.heading': 'Ліцензія',
  'mediaLicense.license.text': 'Діє текст ліцензії Creative Commons:',
  'mediaLicense.license.link': 'CC BY 4.0 – Із зазначенням авторства 4.0 Міжнародна',
  'mediaLicense.scope.heading': 'Що не охоплює ліцензія',
  'mediaLicense.scope.text': 'Тексти цього вебсайту не є частиною ліцензії. Картографічні дані походять з OpenStreetMap і доступні за ліцензією Open Database License (© учасники OpenStreetMap).',
  'mediaLicense.contact': 'Маєш питання щодо використання? Напиши листа на адресу:',
  'mediaLicense.updated': 'Останнє оновлення: жовтень 2026',
  'gallery.previous': 'Попереднє зображення',
  'gallery.next': 'Наступне зображення',
  'gallery.showImage': 'Показати {{title}}',
  'video.play': 'Відтворити {{title}}',
  'videoGallery.summaryOne': '1 відео · {{minutes}} хв',
  'videoGallery.summaryOther': 'Відео: {{count}} · {{minutes}} хв',
  'tags.unesco_heritage': 'Спадщина ЮНЕСКО',
  'tags.landmark': 'Символ міста',
  'tags.church_monastery': 'Церква й монастир',
  'tags.museum_culture': 'Музей і культура',
  'tags.park_nature': 'Парк і природа',
  'tags.viewpoint': 'Оглядовий майданчик',
  'tags.accessible': 'Безбар’єрний доступ',
  'tags.free': 'Безкоштовно',
  'tags.family_friendly': 'Для сімей',
  'tags.concert': 'Концерт',
  'tags.market': 'Ярмарок',
  'tags.guided_tour': 'Екскурсія',
  'tags.festival': 'Фестиваль',
  'tags.exhibition': 'Виставка',
  'tags.sports': 'Спорт',
  'tags.open_air': 'Просто неба',
  'tags.city_history': 'Історія міста',
  'tags.tips_tricks': 'Поради й хитрощі',
  'tags.interview': 'Інтерв’ю',
  'tags.food_drink': 'Їжа й напої',
  'tags.seasonal': 'Сезонне',
  'tags.behind_the_scenes': 'За лаштунками',
  'tags.event_recap': 'Огляд події',
}

export default uk
